module.exports = __webpack_public_path__ + "static/img/06.c93fc8ce.png";